// Sai maheshwar 01/06/2023 2701334326 added function lookup
// Sai maheshwar 01/06/2023 2701326866, 2699389646 added function lookup for exception

import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';

const initialState = {
  loading: false,
  error: null,
  functionsList: null,
};

const lookup = createSlice({
  name: 'lookupSlice',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    fetchFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setLookupData: (state, action) => {
      state.functionsList = action.payload;
    },
  },
});

const {fetchStart, fetchFail, fetchSuccess, setLookupData} = lookup.actions;

export default lookup.reducer;

export const fetchFunctionList = (code) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/function/get/function/${code}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchFail(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setLookupData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchFail(error.message));
      });
  };
};
